import React from "react"
import Image from "../atoms/image"
import styled from "styled-components"
import Button from "../atoms/button"
import media from "styled-media-query"
import TitleSet from "../organisms/title-set"
import MediaQuery from "react-responsive"

const Wrap = styled.div`
  ${media.greaterThan("small")`
    display: flex;
  `}
`
const LeftWrap = styled.div`
  ${media.greaterThan("small")`
    width: 47%;
  `}
`
const RightWrap = styled.div`
  ${media.greaterThan("small")`
    flex: 1;
  `}
`
const ImageWrapSP = styled.div`
  height: 342px;
  margin-bottom: 10px;
  position: relative;
`
const ImageWrapPC = styled.div`
  height: 466px;
  margin-top: 32px;
  position: relative;
`
const StyledDesc = styled.p`
  line-height: 1.9em;
  margin-bottom: 16px;
  ${media.greaterThan("small")`
    margin-top: 32px;
    padding-right: 7px;
  `}
`
const StyledButton = styled(Button)`
  ${media.greaterThan("small")`
    height: 4em;
    width: 96%;
    margin-top: 12px;
  `}
`
const NotesTitle = styled.p`
  color: #aaa;
  font-size: 10px;
  margin: 2.2em 0 0 0;
  ${media.greaterThan("small")`
    margin: 2em 0 0 0;
  `}
`
const StyledNotes = styled.p`
  color: #aaa;
  font-size: 10px;
  margin: 0;
  line-height: 1.5em;
  letter-spacing: -0.3px;
  ${media.greaterThan("small")`
    letter-spacing: 0;
    padding-right: 21px;
  `}
`

const IndexTemplate = props => {
  const title = props.title
  const subTitle = props.subTitle
  const enTitle = props.enTitle
  const imageNameSP = props.imageNameSP
  const imageNamePC = props.imageNamePC
  const umeSP = props.umeSP
  const umePC = props.umePC
  const desc = props.desc
  const notes = props.notes
  const buttonName = props.buttonName
  const buttonFunc = props.buttonFunc
  return (
    <Wrap>
      <LeftWrap>
        <TitleSet title={title} subTitle={subTitle} enTitle={enTitle} />
        <MediaQuery query="(max-width: 449px)">
          <ImageWrapSP>
            <div style={{ height: "358px", marginLeft: "-8px" }}>
              <Image name={imageNameSP} style={{ height: "100%" }} />
            </div>
            <div
              style={{
                position: "absolute",
                top: 0,
                right: "-12px",
                bottom: 0,
                left: 0,
                margin: "39px 0 0 124px",
              }}
            >
              <Image name={umeSP} style={{ height: "100%" }} />
            </div>
          </ImageWrapSP>
        </MediaQuery>
        <StyledDesc>{desc}</StyledDesc>
        <StyledButton onClick={buttonFunc}>{buttonName}</StyledButton>
        <NotesTitle>※注意事項</NotesTitle>
        <StyledNotes>{notes}</StyledNotes>
      </LeftWrap>
      <RightWrap>
        <MediaQuery query="(min-width: 450px)">
          <ImageWrapPC>
            <div style={{ height: "443px", marginLeft: "-8px" }}>
              <Image name={imageNamePC} style={{ height: "100%" }} />
            </div>
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                margin: "17px 0 0 194px",
              }}
            >
              <Image name={umePC} style={{ height: "100%" }} />
            </div>
          </ImageWrapPC>
        </MediaQuery>
      </RightWrap>
    </Wrap>
  )
}
export default IndexTemplate
